import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Signup: React.FC = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    return (
        <>
            <div className="col-12 col-md-8 col-xl-6">
                <div className="h-100 py-3 px-md-3">
                    <div className="row h-100 align-items-center justify-content-center">
                        <div className="col-12 col-sm-8 col-md-11 col-xl-11 col-xxl-10 login-box">
                            <div className="card mb-3">
                                <div className="card-body">
                                    <div className="text-center mb-3 mb-lg-4">
                                        <h1 className="mb-1 text-theme-1">Let's get started👍</h1>
                                        <p className="text-secondary">Provide your few details</p>
                                    </div>

                                    <div className="row gx-3 gx-lg-4">
                                        <div className="col">
                                            <div className="form-floating mb-3">
                                                <input type="text" className="form-control" id="namef" placeholder="Enter first name" defaultValue="Max" autoFocus />
                                                <label htmlFor="namef">First Name</label>
                                            </div>
                                        </div>
                                        <div className="col">
                                            <div className="form-floating mb-3">
                                                <input type="text" className="form-control" id="namel" placeholder="Enter last name" defaultValue="Doe" />
                                                <label htmlFor="namel">Last Name</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-floating mb-3">
                                        <input type="email" className="form-control" id="emailadd" placeholder="Enter email address" defaultValue="info@adminuiux" />
                                        <label htmlFor="emailadd">Email Address</label>
                                    </div>

                                    <div className="input-group mb-3">
                                        <div className="form-floating maxwidth-100">
                                            <select className="form-select" id="code" aria-label="Country code" defaultValue="+44">
                                                <option value="+1">+1</option>
                                                <option value="+44">+44</option>
                                                <option value="+66">+66</option>
                                                <option value="+91">+91</option>
                                            </select>
                                            <label htmlFor="code">Code</label>
                                        </div>
                                        <div className="form-floating">
                                            <input type="text" className="form-control" id="phonen" placeholder="Enter your phone number" />
                                            <label htmlFor="phonen">Phone Number</label>
                                        </div>
                                    </div>

                                    <div className="position-relative">
                                        <div className="form-floating mb-2 mb-lg-3">
                                            <input type={showPassword ? "text" : "password"} className="form-control" id="checkstrength" placeholder="Enter your password" />
                                            <label htmlFor="checkstrength">Password</label>
                                        </div>
                                        <button
                                            className={`btn btn-square btn-link text-theme-1 position-absolute end-0 top-0 mt-2 me-2 ${showPassword ? 'active' : ''}`}
                                            onClick={() => setShowPassword(!showPassword)}
                                            type="button"
                                        >
                                            <i className={`bi bi-eye${showPassword ? '-slash' : ''}`}></i>
                                        </button>
                                    </div>

                                    <div className="position-relative">
                                        <div className="form-floating mb-3">
                                            <input type={showConfirmPassword ? "text" : "password"} className="form-control" id="passwd" placeholder="Confirm your password" />
                                            <label htmlFor="passwd">Confirm Password</label>
                                        </div>
                                        <button
                                            className={`btn btn-square btn-link text-theme-1 position-absolute end-0 top-0 mt-2 me-2 ${showConfirmPassword ? 'active' : ''}`}
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            type="button"
                                        >
                                            <i className={`bi bi-eye${showConfirmPassword ? '-slash' : ''}`}></i>
                                        </button>
                                    </div>

                                    <Link to="/auth/signup-success" className="btn btn-lg btn-theme w-100 mb-4">Sign up</Link>
                                    <div className="text-center">
                                        Already have account? <Link to="/auth/login">Login</Link> here.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Signup;
